/* ============================================================
   Gourmet Mallorca — gemeinsames Produktkarussell
   Gehoert nach: assets/gm-carousel.js
   Einbinden mit: {{ 'gm-carousel.js' | asset_url | script_tag }}  (defer)

   Wichtig: Initialisiert JEDE .gm-c-root auf der Seite, nicht feste IDs.
   Dadurch koennen mehrere Karussells gleichzeitig auf einer Seite laufen.

   10.10.: Tablet (769–1024 px) zeigt zwei statt drei Karten. Die Punkte
   rechnen jetzt mit der tatsaechlich sichtbaren Kartenzahl — mobil ein
   Punkt pro Karte, vorher sprang jeder Punkt um drei Karten.
   Dazu: Button "In den Warenkorb" auf Karten mit data-gm-add.
   ============================================================ */
(function () {
  if (window.gmCarouselReady) return;   /* doppeltes Einbinden abfangen */
  window.gmCarouselReady = true;

  function init(root) {
    if (root.dataset.gmcInit === '1') return;
    root.dataset.gmcInit = '1';

    var track = root.querySelector('.gm-c-track');
    var viewport = root.querySelector('.gm-c-viewport');
    if (!track || !viewport || !track.children.length) return;

    var prevBtn = root.querySelector('.gm-c-prev');
    var nextBtn = root.querySelector('.gm-c-next');
    var dotsWrap = root.querySelector('.gm-c-dots');
    var cards = Array.prototype.slice.call(track.children);
    var current = 0;
    var resizeTimer = null;
    var dotsPer = 0;

    function isMobile() { return window.innerWidth <= 768; }
    function perView() {
      if (isMobile()) return 1;
      return window.innerWidth <= 1024 ? 2 : 3;
    }

    function activeDot(i) {
      if (!dotsWrap) return;
      Array.prototype.forEach.call(dotsWrap.children, function (d, n) {
        d.classList.toggle('is-active', n === i);
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      var per = perView();
      if (per === dotsPer) return;
      dotsPer = per;
      dotsWrap.innerHTML = '';
      var pages = Math.ceil(cards.length / per);
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'gm-c-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Zu Seite ' + (i + 1));
        (function (idx) {
          d.addEventListener('click', function () {
            var p = perView();
            if (isMobile()) {
              var target = cards[idx * p] || cards[cards.length - 1];
              viewport.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
            } else {
              current = Math.min(idx * p, Math.max(0, cards.length - p));
              update();
            }
          });
        })(i);
        dotsWrap.appendChild(d);
      }
    }

    function update() {
      var p = perView();
      if (isMobile()) {
        cards.forEach(function (c) { c.style.width = ''; c.style.minWidth = ''; });
        track.style.transform = 'none';
      } else {
        var w = viewport.offsetWidth / p;
        cards.forEach(function (c) { c.style.width = w + 'px'; c.style.minWidth = w + 'px'; });
        var max = Math.max(0, cards.length - p);
        current = Math.min(current, max);
        track.style.transform = 'translateX(-' + (current * w) + 'px)';
      }
      var scrollable = cards.length > p;
      if (prevBtn) prevBtn.classList.toggle('is-hidden', !scrollable);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', !scrollable);
      activeDot(Math.floor(current / p));
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      var mx = Math.max(0, cards.length - perView());
      current = (current <= 0) ? mx : current - 1;
      update();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var mx = Math.max(0, cards.length - perView());
      current = (current >= mx) ? 0 : current + 1;
      update();
    });

    viewport.addEventListener('scroll', function () {
      if (!isMobile() || !cards.length) return;
      var w = cards[0].offsetWidth || 1;
      activeDot(Math.round(viewport.scrollLeft / w));
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { buildDots(); update(); }, 150);
    });

    buildDots();
    update();
  }

  /* ── Direkt in den Warenkorb (nur Karten mit data-gm-add) ──
     Legt das Produkt per AJAX in den Korb, OHNE den Drawer zu oeffnen:
     der Kunde steht auf einer Weinseite und soll dort bleiben. Bestaetigt
     wird ueber den Button-Text; Zaehler im Header und Drawer-Inhalt
     frischt gmDrawerRefresh (sections/cart-drawer.liquid) still auf.
     Die AJAX-Endpunkte laufen immer ohne Sprachpraefix (siehe gm-gift.js). */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gm-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-gm-add'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      btn.textContent = btn.getAttribute('data-ok') || label;
      btn.classList.add('is-done');
      if (typeof window.gmDrawerRefresh === 'function') {
        window.gmDrawerRefresh();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    }).catch(function () {
      btn.textContent = btn.getAttribute('data-err') || label;
    }).then(function () {
      setTimeout(function () {
        btn.textContent = label;
        btn.classList.remove('is-done');
        btn.disabled = false;
      }, 2500);
    });
  });

  function initAll() {
    document.querySelectorAll('.gm-c-root').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Sections werden nachtraeglich eingefuegt oder neu geladen */
  document.addEventListener('shopify:section:load', initAll);
})();
